// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Banner/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Banner, view, Button} from '@sail/ui';

export const Basic = () => (
  <view.div
    css={{
      layout: 'column',
      gap: 'medium',
    }}
  >
    <Banner
      type="default"
      onDismiss={() => console.log('hello world')}
      title="Neutral title"
      description="A short description"
      actions={
        <Button onPress={() => console.log('hello world')}>Button</Button>
      }
    />

    <Banner
      type="caution"
      title="Check your bank details"
      description="Your bank account information must be verified before receiving payouts."
      onDismiss={() => console.log('hello world')}
      actions={
        <>
          <Button onPress={() => console.log('hello world')}>
            Update bank account
          </Button>
          <Button onPress={() => console.log('hello world')}>Learn more</Button>
        </>
      }
    />

    <Banner
      type="critical"
      title="Check your bank details"
      description="Your bank account information must be verified before receiving payouts."
      actions={
        <Button onPress={() => console.log('hello world')}>
          Update bank account
        </Button>
      }
    />
  </view.div>
);
